import React, { useEffect, useState } from 'react';
import './Applications.css';
import SectionHeader from '../../components/SectionHeader/SectionHeader';
import publicAxios from '../../utils/axios/publicAxios';
import { Link, useNavigate } from 'react-router-dom';
import moment from 'moment';

const Applications = () => {
  const navigate = useNavigate();

  const [applications, setApplications] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchMode, setSearchMode] = useState(false);

  const stripHtmlAndTruncate = (html, maxLength = 30) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  const fetchApplications = async (page = 1) => {
    try {
      setLoading(true);
      const response = await publicAxios.get(`/public/forms?page=${page}`);
      setApplications(response.data.forms);
      setTotalPages(response.data.totalPages);
      setCurrentPage(page);
    } catch (error) {
      console.error('Error fetching applications', error);
      setApplications([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchSearchedApplications = async (page = 1) => {
    try {
      setLoading(true);
      const response = await publicAxios.get(`/public/search-forms?query=${searchTerm.trim()}&page=${page}`);
      setApplications(response.data.forms);
      setTotalPages(response.data.totalPages);
      setCurrentPage(page);
    } catch (error) {
      console.error('Error searching applications', error);
      setApplications([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApplications();
  }, []);

  const handleSearch = () => {
    if (!searchTerm.trim()) {
      setSearchMode(false);
      fetchApplications(1);
    } else {
      setSearchMode(true);
      fetchSearchedApplications(1);
    }
  };

  const handleClickApplication = (id, e) => {
    if (e.target.closest('button') || e.target.closest('input')) return;
    navigate(`/application/${id}`);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      const nextPage = currentPage + 1;
      searchMode ? fetchSearchedApplications(nextPage) : fetchApplications(nextPage);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      const prevPage = currentPage - 1;
      searchMode ? fetchSearchedApplications(prevPage) : fetchApplications(prevPage);
    }
  };

  return (
    <div className="applications">
      <SectionHeader title="Applications" subtitle="Stay Updated with the Latest Applications" />
      <div className="applications-header">
        <div className='applications-search-input'>
          <input
            type="text"
            placeholder="Search applications by title..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button className='applications-search-btn' onClick={handleSearch}>Search</button>
        </div>
      </div>
      <div className="applications-list">
        {loading ? (
          <div>Loading...</div>
        ) : applications.length ?
          applications.map((app) => (
            <div className="applications-card" key={app._id} onClick={(e) => handleClickApplication(app._id, e)}>
              <img src={app.imageUrl} alt={app.title} className="applications-image" />
              <div className="applications-content">
                <h3>{app.title}</h3>
                <p className="applications-date">{moment(app.createdAt).format('MMMM DD, YYYY')}</p>
                <p className="applications-description">
                  {stripHtmlAndTruncate(app.description, 150)}
                </p>
                <Link className='applications-read-more' to={`/application/${app._id}`}>Read more...</Link>
              </div>
            </div>
          ))
          : (
            <div>No applications found.</div>
          )}
      </div>
      <div className="applications-pagination-controls">
        <button onClick={handlePreviousPage} disabled={currentPage === 1}>Previous</button>
        <span>Page {currentPage} of {totalPages}</span>
        <button onClick={handleNextPage} disabled={currentPage === totalPages}>Next</button>
      </div>

      <div className="applications-back-to-home">
        <Link to={'/'}>Back to Home</Link>
      </div>
    </div>
  );
};

export default Applications;